import "../../../css/components/About.css"
import Accordion from "../../components/Accordion";

const About = () => {
    return (
      <div className="about-section">
        <div className="about-section-content">
          <div className="nav-bold secondary">About Us</div>
          <h2 className="primary">
            Why <span style={{ fontStyle: "italic" }}>Choose Us?</span>
          </h2>
          <div className="about-accordion-grid">
            <Accordion title="PERSONALISED ADVICE">
              Tailored strategies built around your goals.
            </Accordion>
            <Accordion title="BUILT FOR SERIOUS SAVERS">
              From first steps to large portfolios.
            </Accordion>
            <Accordion title="TRUSTED & REGULATED">
              FCA regulated. Advice you can rely on.
            </Accordion>
            <Accordion title="FUTURE-PROOF PLANNING">
              Your plan evolves as your life does.
            </Accordion>
            <Accordion title="AFFORDABLE BY DESIGN">
              Built to fit your budget - not break it.
            </Accordion>
            <Accordion title="TAX EFFICIENT">
              Keep more of what you earn.
            </Accordion>
            <Accordion title="ACCESS TO MULTIPLE LENDERS">
              We compare a wide range to find the right fit.
            </Accordion>
            <Accordion title="SPECIALIST EXPERTISE">
              Complex cases handled properly - health, business, trusts,
              property, and more.
            </Accordion>
          </div>
        </div>
      </div>
    );
}

export default About;